










import { Component, Vue } from 'vue-property-decorator';
import Header from '@/components/common/Header.vue';
import Footer from '@/components/common/Footer.vue';
import ActionReportTable from '@/components/action_report/ActionReportTable.vue';

@Component({
  components: {
    Header,
    ActionReportTable,
    Footer,
  },
})
export default class ActionReportList extends Vue {}
